/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { TextField, MenuItem } from '@mui/material';
import { getDateComparisonFilter } from 'modules/scenario/function';
import { selectVisualFilters } from 'modules/scenario/selectors';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const ComparisonPeriodFilter = ({ value, onChange }) => {
  const visualFilters = useSelector(selectVisualFilters);
  const [comparisonDateList, setComparisonDateList] = useState([]);
  //
  useEffect(() => {
    // Set comparison filter list
    const comparisonFilter = getDateComparisonFilter(visualFilters);
    if (comparisonFilter) {
      setComparisonDateList(comparisonFilter);
    }
  }, [visualFilters]);

  const handleDropdownChange = (event) => {
    onChange?.(event.target.value);
  };

  return (
    <TextField
      select
      label="Comparison Period"
      value={value ?? ''}
      onChange={handleDropdownChange}
      size="small"
      sx={{
        minWidth: 140,
        width: { sm: 350 },
        pb: { sm: 2, md: 0, lg: 0 },
      }}
      fullWidth
    >
      {comparisonDateList.map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default ComparisonPeriodFilter;
